import { QRCodeSVG } from "qrcode.react";
import { useRef } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

/* eslint-disable react/prop-types */
export default function TicketQrCard({ ticket }) {
    const componentRef = useRef();
    const [year, month, day] = ticket.Purchase.Event.fecha.split("-");
    const localDate = new Date(year, month - 1, day);

    const handleDownloadPDF = async () => {
        if (!componentRef.current) return;

        // Guardar estilos originales
        const originalBg = componentRef.current.style.backgroundColor;
        const originalColor = componentRef.current.style.color;

        // Aplicar fondo blanco y texto negro
        componentRef.current.style.backgroundColor = "#fff";
        componentRef.current.style.color = "#000";

        // Ocultar el botón antes de capturar
        const button = componentRef.current.querySelector(".exclude-from-pdf");
        if (button) button.style.display = "none";

        // Capturar el contenido del componente
        const canvas = await html2canvas(componentRef.current, {
            scale: 3,
            useCORS: true,
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = pageWidth - 40;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (imgHeight > pageHeight - 40) {
            const newImgWidth = (pageHeight - 40) * (imgWidth / imgHeight);
            const offsetX = (pageWidth - newImgWidth) / 2;
            pdf.addImage(
                imgData,
                "PNG",
                offsetX,
                20,
                newImgWidth,
                pageHeight - 40
            );
        } else {
            const offsetX = (pageWidth - imgWidth) / 2;
            const offsetY = (pageHeight - imgHeight) / 2;
            pdf.addImage(imgData, "PNG", offsetX, offsetY, imgWidth, imgHeight);
        }

        pdf.save(`ticket-${ticket.id}.pdf`);

        // Restaurar estilos originales
        componentRef.current.style.backgroundColor = originalBg;
        componentRef.current.style.color = originalColor;

        // Volver a mostrar el botón
        if (button) button.style.display = "block";
    };

    return (
        <div
            ref={componentRef}
            className="p-4 mt-4 mb-20 max-w-sm mx-auto rounded-lg bg-zinc-900"
        >
            <div className="w-full border p-2 border-zinc-900 rounded-lg">
                <div className="p-6 sm:p-8 bg-white">
                    <div className="mx-auto w-full max-w-[220px] sm:max-w-[260px] md:max-w-[300px]">
                        <QRCodeSVG
                            value={ticket.id}
                            size={300}
                            className="m-auto"
                            style={{ width: "100%", height: "auto" }}
                        />
                    </div>
                </div>
                <p className="text-center mt-4 mb-6 text-2xl font-semibold">
                    {ticket.id}
                </p>

                <div className="flex flex-col ">
                    <p className="text-xl">
                        {ticket.Ticket.categoria} -{" "}
                        {ticket.Purchase.Event.nombre}
                    </p>
                    <p className="text-xl">
                        {localDate.toLocaleDateString()}{" "}
                        {ticket.Purchase.Event.hora}
                        {" - "}
                        {ticket.Purchase.Event.ubicacion}
                    </p>
                    <p className="text-lg"></p>
                    {ticket.pass ? (
                        <p className="text-red-600 text-lg">Entrada canjeada</p>
                    ) : (
                        <p className="text-green-600 text-lg">Activa</p>
                    )}
                </div>
                <div className="border-b my-3"></div>
                <div className="mb-3">
                    <p className="text-center text-sm">
                        fecha de compra:{" "}
                        {new Date(
                            ticket.Purchase.createdAt
                        ).toLocaleDateString()}
                        ,{" "}
                        {new Date(
                            ticket.Purchase.createdAt
                        ).toLocaleTimeString()}
                    </p>
                    <p className="text-center text-sm">
                        orden de compra nro: {ticket.Purchase.id}
                    </p>
                </div>
            </div>
            <div>
                <button
                    onClick={handleDownloadPDF}
                    className="exclude-from-pdf w-full text-lg px-6 py-3 bg-rose-600 text-white rounded-lg shadow-md hover:bg-rose-500 transition"
                >
                    Descargar PDF
                </button>
            </div>
        </div>
    );
}
